import polyfillsCoreJS from './polyfillsCoreJS';
import polyfillsIntl from './polyfillsIntl';
import polyfillsRAF from './polyfillsRequestAnimationFrame';
import polyfillsScroll from './polyfillsScroll';

export const polyfills = [...polyfillsCoreJS, ...polyfillsRAF, ...polyfillsScroll, ...polyfillsIntl()];
